<template>
  <div class="container-block-plan container rounded md-elevation-6 mb-5 overflow-hidden">
    <div class="front col-12">
      <div class="title-block mt-5 mb-4">
        <h1>{{ blockType }}</h1>
        <span class="line-divider"></span>
      </div>
      <div class="plans pt-3 mb-2">
        <slot></slot>
      </div>
      <div class="">
        <div class="col-3 p-0">
          <btn-start-screen @click.native="$emit('handleButton')" class="mb-5" text="contratar"></btn-start-screen>
        </div>
      </div>
    </div>
    <div class="back row">
      <div class="super"></div>
      <img :src="bgSwich()" alt="">
    </div>
  </div>
</template>

<script>
  import BtnStartScreen from "./BtnStartScreen";
  import { FAMILY, PLAY, GAMER, LIGHT } from "../consts/typePlans"
  import FAMILY_BG from '../assets/background/bg_plan_type_family.jpg'
  import PLAY_BG from '../assets/background/bg_plan_type_play.jpg'
  import GAMER_BG from '../assets/background/bg_plan_type_gamer.jpg'
  import LIGHT_BG from '../assets/background/bg_plan_type_light.jpg'
  import DEFAULT_BG from '../assets/background/bg_x_black_for_component.jpg'

  export default {
    name: "ContainerBlockPlan",
    components: {BtnStartScreen},
    props: {
      blockType: { default: "Block Type" }
    },
    methods: {
      bgSwich() {

        switch (this.blockType) {
          case FAMILY:
            return FAMILY_BG;
          case PLAY:
            return PLAY_BG;
          case GAMER:
            return GAMER_BG;
          case LIGHT:
            return LIGHT_BG;
          default:
            return DEFAULT_BG
        }

      }
    }
  }
</script>

<style scoped lang="scss">
  .container-block-plan {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
  }

  .front {
    place-content: stretch;
    display: flex;
    flex-direction: column;
    z-index: 2;
  }
  
  .back{
    position: absolute;
    z-index: 1;
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    background-color: #000;
    .super {
      position: absolute;
      background: radial-gradient(ellipse at center, rgba(0,0,0,.24) 0%,rgba(0,0,0,.35) 82%, rgba(0,0,0,.65) 100%);
      z-index: 2;
      width: 100%;
      height: 100%;
    }
    img {
      object-fit: cover;
      display: flex;
      width: 100%;
      height: 100%;
      align-self: center;
    }
  }


  .title-block {
    display: flex;
    flex-direction: column;
    filter: drop-shadow(3px 3px 2px #390000);
    h1 {
      letter-spacing: 0.15em;
      padding-top: 11px;
      margin-top: 0;
      margin-bottom: 18px;
      font-size: 3.8em;
      color: #ff0000;
    }
    .line-divider {
      display: block;
      background-color: #ff0000;
      width: 70px;
      height: 7px;
    }
  }

</style>
